import React from 'react';
import { Button, Grid, makeStyles, useMediaQuery, useTheme } from '@material-ui/core';
import MaterialTable from '../../../Components/Misc/Tables/MaterialTableSimple';
import * as lang from '../../../Constants/strings';
import { tasks_score_validation } from '../../../Components/Misc/Tables/TableHeaders';
import AreaSelectModal from "../Modals/AreaSelect";
import SelectDateModal from "../Modals/SelectIntervalModal";
import axios from 'axios';
import * as requestHeaders from '../../../Constants/requestHeaders';
import moment from "moment";
import ScoreValidationModal from '../Modals/ScoreValidationModal';
import { checkPermissions } from '../../../Functions/permissionHide';

const useStyles = makeStyles(theme => ({
    root: {
        margin: theme.spacing(2),
        marginTop: theme.spacing(10),
        width: 'auto'
    },
    shortcut: {
        marginBottom: theme.spacing(10),
        margin: theme.spacing(1),
        transform: 'rotate(180deg)',
    },
    margin: {
        margin: theme.spacing(2, 2, 2, 2),
        width: 'auto'
    },
    leftIcon: {
        marginRight: theme.spacing(1),
    },
    fabGrid: {
        margin: theme.spacing(-5, 0, 0, 0),
        position: 'absolute',
    },
    fab: {
        marginRight: theme.spacing(4),
    },
    filterButtonsContainer: {
        marginTop: "-10px",
        display: "flex",
        justifyContent: "start"
    },
    filterButtons: {
        marginRight: "5px",
    }
}));

export default function TaskScoreValidation(props) {
    const { language, userPermissions } = props;
    const [rowsPerPage, setRowsPerPage] = React.useState(25);
    const classes = useStyles();
    const theme = useTheme();
    const tiny = useMediaQuery(theme.breakpoints.down('xs'));
    const [data, setData] = React.useState([]);
    const [selectedId, setSelectedId] = React.useState(null);
    const [modal, setModal] = React.useState(false);

    const [selectAreaModal, setSelectedAreaModal] = React.useState(false);
    const [selectDateIntervalModal, setSelectDateIntervalModal] = React.useState(false);
    const [changeFilter, setChangeFilter] = React.useState(false);

    const [selectedArea, setSelectedArea] = React.useState(null);
    const [interval, setInterval] = React.useState({
        startDate: moment(new Date).subtract(1, 'months').format("YYYY-MM-DD HH:mm:ss"),
        endDate: moment(new Date).format("YYYY-MM-DD HH:mm:ss")
    });

    React.useEffect(() => {
        getClosedInstallations();
    }, [selectedArea, interval]);

    const resetFilters = () => {
        setInterval({
            startDate: moment(new Date).subtract(1, 'months').format("YYYY-MM-DD HH:mm:ss"),
            endDate: moment(new Date).format("YYYY-MM-DD HH:mm:ss")
        });
        setSelectedArea(null);
        setChangeFilter(false);
    };

    const getClosedInstallations = async () => {
        try {
            const response = await axios.get('/api/close_installations', {
                ...requestHeaders.getGetHeader(),
                params: {
                    areaCode: selectedArea !== null ? selectedArea.AREA_CODE : undefined,
                    startDate: interval ? interval.startDate : undefined,
                    endDate: interval ? interval.endDate : undefined,
                    no_score: true,
                }
            });
            let formatedTasks = [];

            if (response.status === 200) {
                formatedTasks = response.data.data.map(task => ({
                    ...task
                }));
                setData(formatedTasks ? formatedTasks : []);
            } else {
                console.error("Error: ", response.data.message);
                setData(formatedTasks);
            }
        } catch (error) {
            console.log("Error: ", error);
        }
    }

    React.useEffect(() => {
        getClosedInstallations();
    }, []);

    return (
        <React.Fragment>
            <ScoreValidationModal
                language={language}
                open={modal}
                close={() => setModal(false)}
                reopen={() => setModal(true)}
                id={selectedId}
                lockAllFields={!checkPermissions(userPermissions, {
                    parent: "INSTALLATION",
                    name: "VALIDATE_SCORE",
                })}
                lockOverwrite={!checkPermissions(userPermissions, {
                    parent: "INSTALLATION",
                    name: "OVERWRITE_SCORE",
                })}
                refeatchTaskData={() => getClosedInstallations()}
            />
            <AreaSelectModal
                open={selectAreaModal}
                onClose={() => setSelectedAreaModal(false)}
                language={language}
                selectedArea={selectedArea}
                setSelectedArea={(e) => {
                    setChangeFilter(true);
                    setSelectedArea(e.target.value);
                }}
                callback={() => {
                    setSelectedAreaModal(false)
                }}
            />
            <SelectDateModal
                open={selectDateIntervalModal}
                onClose={() => setSelectDateIntervalModal(false)}
                language={language}
                callback={(startDate, endDate) => {
                    setInterval({ startDate, endDate })
                    setSelectDateIntervalModal(false);
                    setChangeFilter(true);
                }}
            />

            <Grid container component="main" className={classes.margin}>
                <Grid item xs={12}>
                    <div className={classes.filterButtonsContainer}>
                        <Button
                            className={classes.filterButtons}
                            color="primary"
                            onClick={() => setSelectDateIntervalModal(true)}
                        >
                            {lang.SELECT_INTERVAL_DATE[language]}
                        </Button>
                        <Button
                            className={classes.filterButtons}
                            color="primary"
                            onClick={() => setSelectedAreaModal(true)}
                        >
                            {lang.AREA_SELECT[language]}
                        </Button>
                        <Button
                            className={classes.filterButtons}
                            color="secondary"
                            onClick={() => resetFilters()}
                        >
                            {lang.RESET[language]}
                        </Button>
                    </div>
                </Grid>


                <Grid item xs={12}>
                    <MaterialTable
                        tiny={tiny}
                        title={lang.SCORE_VALIDATION[language]}
                        language={language}
                        data={data}
                        rowsPerPage={rowsPerPage}
                        onRowsPerPageChange={(value) => setRowsPerPage(value)}
                        header={tasks_score_validation(language)}
                        dense={false}
                        // openAddModal={props.openAddModal}
                        openRowModal={(id) => {
                            setSelectedId(id);
                            setModal(true);
                        }}
                        clickLabel="TASK_ID"
                        hideAddBtn={true}
                    />
                </Grid>
            </Grid>
        </React.Fragment>
    )
}
